import { createReducer } from '@reduxjs/toolkit'
import { map, reduce, without, includes } from 'lodash'
import ActionTypes from '../types.js'

export const initialState = {
  selectedIds: [],
  bulkShow: {
    awaitingAsyncResponse: false,
  },
  bulkHide: {
    awaitingAsyncResponse: false,
  },
}

export const commentModeration = createReducer(initialState, builder => {
  builder
    .addCase(ActionTypes.COMMENT_SELECTION_CHANGE, (state, action) => selectionChange(state, action))
    .addCase(ActionTypes.COMMENTS_SELECT_VISIBLE, (state, action) => selectVisible(state, action))
    .addCase(ActionTypes.COMMENTS_SELECT_HIDDEN, (state, action) => selectHidden(state, action))
    .addCase(ActionTypes.COMMENTS_SELECT_ALL, (state, action) => selectAll(state, action))
    .addCase(ActionTypes.COMMENTS_DESELECT_ALL, (state, action) => deselectAll(state, action))
    .addCase(ActionTypes.BULK_SHOW_COMMENTS_START, (state, action) => startBulkShowWait(state))
    .addCase(ActionTypes.BULK_HIDE_COMMENTS_START, (state, action) => startBulkHideWait(state))
    .addMatcher(
      ({ type }) => includes([ActionTypes.BULK_SHOW_COMMENTS_SUCCESS, ActionTypes.BULK_SHOW_COMMENTS_ERROR], type),
      (state, action) => endBulkShowWait(state)
    )
    .addMatcher(
      ({ type }) => includes([ActionTypes.BULK_HIDE_COMMENTS_SUCCESS, ActionTypes.BULK_HIDE_COMMENTS_ERROR], type),
      (state, action) => endBulkHideWait(state)
    )
})

// Helper functions

function selectionChange(state, action) {
  const {
    payload: { id, selected },
  } = action
  selected ? selectComment(state, id) : deselectComment(state, id)
  return state
}

function selectVisible(state, action) {
  const { payload: comments } = action
  const filteredIds = reduce(
    comments,
    (result, value, key) => {
      const comment = value
      if (comment.visible) {
        result.push(comment.id)
      }
      return result
    },
    []
  )
  state.selectedIds = filteredIds
  return state
}

function selectHidden(state, action) {
  const { payload: comments } = action
  const filteredIds = reduce(
    comments,
    (result, value, key) => {
      const comment = value
      if (!comment.visible) {
        result.push(comment.id)
      }
      return result
    },
    []
  )
  state.selectedIds = filteredIds
  return state
}

function selectAll(state, action) {
  const { payload: comments } = action
  const commentIds = map(comments, comment => comment.id)
  state.selectedIds = commentIds
  return state
}

function deselectAll(state, action) {
  state.selectedIds = []
  return state
}

function selectComment(state, resourceId) {
  const selectedIds = state.selectedIds
  if (!selectedIds.includes(resourceId)) {
    state.selectedIds.push(resourceId)
  }
  return state
}

function deselectComment(state, resourceId) {
  if (includes(state.selectedIds, resourceId)) {
    state.selectedIds = without(state.selectedIds, resourceId)
  }
  return state
}

function startBulkShowWait(state) {
  state.bulkShow.awaitingAsyncResponse = true
  return state
}

function endBulkShowWait(state) {
  state.bulkShow.awaitingAsyncResponse = false
  return state
}

function startBulkHideWait(state) {
  state.bulkHide.awaitingAsyncResponse = true
  return state
}

function endBulkHideWait(state) {
  state.bulkHide.awaitingAsyncResponse = false
  return state
}

// selectors

function getBase(state) {
  return state.commentModeration
}

export function getSelectedCommentIds(state, props) {
  return getBase(state).selectedIds
}

export function getAwaitingBulkShowAsyncResponse(state, props) {
  return getBase(state).bulkShow.awaitingAsyncResponse
}

export function getAwaitingBulkHideAsyncResponse(state, props) {
  return getBase(state).bulkHide.awaitingAsyncResponse
}

export default commentModeration
